import { IconsTypesProps } from '../icons/types';

export const ValveScreenIcon1 = ({ width = 58, height = 57 }: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="1828 825 950 1050"
    overflow="visible"
  >
    <g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M2003 1789.25C1980.31 1789.25 1961.75 1770.69 1961.75 1748 1961.75 1725.31 1980.31 1706.75 2003 1706.75 2025.69 1706.75 2044.25 1725.31 2044.25 1748 2044.25 1770.69 2025.69 1789.25 2003 1789.25ZM2095.81 1722.22C2093.75 1714.66 2090.66 1707.44 2086.88 1700.91L2095.47 1675.12 2075.88 1655.53 2050.09 1664.12C2043.22 1660.34 2036 1657.25 2028.44 1655.19L2016.75 1631.12 1989.25 1631.12 1977.22 1655.19C1969.66 1657.25 1962.44 1660.34 1955.91 1664.12L1930.12 1655.53 1910.53 1675.12 1919.12 1700.91C1915.34 1707.78 1912.25 1715 1910.19 1722.56L1886.12 1734.25 1886.12 1761.75 1910.19 1773.78C1912.25 1781.34 1915.34 1788.56 1919.12 1795.09L1910.53 1820.88 1930.12 1840.47 1955.91 1831.88C1962.78 1835.66 1970 1838.75 1977.56 1840.81L1989.59 1864.88 2017.09 1864.88 2029.12 1840.81C2036.69 1838.75 2043.91 1835.66 2050.44 1831.88L2076.22 1840.47 2095.81 1820.88 2087.22 1795.09C2091 1788.22 2094.09 1781 2096.16 1773.44L2120.22 1761.41 2120.22 1733.91 2095.81 1722.22Z"
                fill="#637381"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M2638 1044.25C2615.31 1044.25 2596.75 1025.69 2596.75 1003 2596.75 980.313 2615.31 961.75 2638 961.75 2660.69 961.75 2679.25 980.313 2679.25 1003 2679.25 1025.69 2660.69 1044.25 2638 1044.25ZM2730.81 977.219C2728.75 969.656 2725.66 962.438 2721.88 955.906L2730.47 930.125 2710.88 910.531 2685.09 919.125C2678.22 915.344 2671 912.25 2663.44 910.188L2651.75 886.125 2624.25 886.125 2612.22 910.188C2604.66 912.25 2597.44 915.344 2590.91 919.125L2565.12 910.531 2545.53 930.125 2554.12 955.906C2550.34 962.781 2547.25 970 2545.19 977.563L2521.12 989.25 2521.12 1016.75 2545.19 1028.78C2547.25 1036.34 2550.34 1043.56 2554.12 1050.09L2545.53 1075.88 2565.12 1095.47 2590.91 1086.88C2597.78 1090.66 2605 1093.75 2612.56 1095.81L2624.59 1119.88 2652.09 1119.88 2664.12 1095.81C2671.69 1093.75 2678.91 1090.66 2685.44 1086.88L2711.22 1095.47 2730.81 1075.88 2722.22 1050.09C2726 1043.22 2729.09 1036 2731.16 1028.44L2755.22 1016.41 2755.22 988.906 2730.81 977.219Z"
                fill="#637381"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
        <path
          d="M2520.31 897.354C2584.18 832.355 2688.65 831.44 2753.65 895.31 2809.25 949.952 2819.03 1036.06 2777.08 1101.78"
          stroke="#637381"
          strokeWidth="40.3125"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="8"
          strokeOpacity="1"
          fill="none"
          fillRule="evenodd"
        />
        <path
          d="M2133.08 1849.51C2077.02 1921.35 1973.34 1934.14 1901.5 1878.08 1834.41 1825.73 1818.13 1730.95 1863.92 1659.22"
          stroke="#637381"
          strokeWidth="40.3125"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="8"
          strokeOpacity="1"
          fill="none"
          fillRule="evenodd"
        />
        <path
          d="M0 0 656.392 761.871"
          stroke="#637381"
          strokeWidth="40.3125"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="8"
          strokeOpacity="1"
          fill="none"
          fillRule="evenodd"
          transform="matrix(1 0 0 -1 1864 1659.87)"
        />
        <path
          d="M0 0 643.998 747.729"
          stroke="#637381"
          strokeWidth="40.3125"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="8"
          strokeOpacity="1"
          fill="none"
          fillRule="evenodd"
          transform="matrix(1 0 0 -1 2133 1849.73)"
        />
      </g>
    </g>
  </svg>
);
